import * as React from 'react';

import {StopsData} from 'core/RateConfirmation/types';

import styles from './styles.module.scss';

const StopsInfo: React.FC<{stopsInfo: StopsData}> = ({stopsInfo}) => {
    const trStops = stopsInfo.map((stop, index) => {
        const freights = stop.freights?.map((freight, frIndex) => {
            return (
                <React.Fragment key={frIndex}>
                    <div className={styles.freight_row}>
                        <div>{freight.psc}</div>
                        <div>{freight.weight}</div>
                    </div>
                    <div className={styles.freight_row}>
                        <div className={styles.freight_col}>{freight.stackable.title}</div>
                        <div className={styles.freight_col}>{freight.stackable.value}</div>
                    </div>
                    <div className={styles.freight_row}>
                        <div className={styles.freight_col}>{freight.hazmat.title}</div>
                        <div className={styles.freight_col}>{freight.hazmat.value}</div>
                    </div>
                </React.Fragment>
            );
        });
        return (
            <React.Fragment key={index}>
                <tr className={styles.stop}>
                    <td>
                        <div className={styles.stop_title}>
                            <strong>{stop.stopName}</strong>
                        </div>
                        <p>
                            <strong>{stop.facility}</strong> <br /> {stop.facilityAddress}
                        </p>
                    </td>
                    <td>
                        {stop.timeType.value === 'FCFS' ? (
                            <>
                                <div className={styles.stop_row}>
                                    <div className={styles.stop_col}>{stop.timeType.title}</div>
                                    <div className={styles.stop_col}>{stop.timeType.value}</div>
                                </div>
                                <div className={styles.stop_row}>
                                    <div className={styles.stop_col}>{stop.timeFrom.title}</div>
                                    <div className={styles.stop_col}>{stop.timeFrom.value}</div>
                                </div>
                                <div className={styles.stop_row}>
                                    <div className={styles.stop_col}>{stop.timeTo.titleTo}</div>
                                    <div className={styles.stop_col}>{stop.timeTo.value}</div>
                                </div>
                            </>
                        ) : null}
                        {stop.timeType.value === 'APPT' ? (
                            <>
                                <div className={styles.stop_row}>
                                    <div className={styles.stop_col}>{stop.timeType.title}</div>
                                    <div className={styles.stop_col}>{stop.timeType.value}</div>
                                </div>
                                <div className={styles.stop_row}>
                                    <div className={styles.stop_col}>{stop.timeTo.titleTime}</div>
                                    <div className={styles.stop_col}>{stop.timeTo.value}</div>
                                </div>
                            </>
                        ) : null}

                        {stop.timeType.value === 'ASAP' || stop.timeType.value === 'DIRECT' ? (
                            <>
                                <div className={styles.stop_row}>
                                    <div className={styles.stop_col}>{stop.timeType.title}</div>
                                    <div className={styles.stop_col}>{stop.timeType.value}</div>
                                </div>
                                <div className={styles.stop_row}>
                                    <div className={styles.stop_col}>{stop.timeTo.titleBy}</div>
                                    <div className={styles.stop_col}>{stop.timeTo.value}</div>
                                </div>
                            </>
                        ) : null}
                    </td>
                    <td className={styles.freight}>{freights}</td>
                </tr>
                <tr className={styles.stop_note}>
                    {stop.dispatcherNote.value ? (
                        <td colSpan={3}>
                            <strong>{stop.dispatcherNote.title}&nbsp;</strong>
                            <em>{stop.dispatcherNote.value}</em>
                        </td>
                    ) : null}
                </tr>
            </React.Fragment>
        );
    });

    return <tbody className={styles.tbody}>{trStops}</tbody>;
};

export default StopsInfo;
